module.exports = __webpack_public_path__ + "img/562-G.8d5520ea.png";